var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "M12 14h-2v26a4 4 0 0 0 4 4h20a4 4 0 0 0 4-4V14zm21.236-6L30 4H18l-3.236 4H6v4h36V8z"
  })));
};
export { SvgTrash as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDE0SDEwVjQwQzEwIDQxLjA2MDkgMTAuNDIxNCA0Mi4wNzgzIDExLjE3MTYgNDIuODI4NEMxMS45MjE3IDQzLjU3ODYgMTIuOTM5MSA0NCAxNCA0NEgzNEMzNS4wNjA5IDQ0IDM2LjA3ODMgNDMuNTc4NiAzNi44Mjg0IDQyLjgyODRDMzcuNTc4NiA0Mi4wNzgzIDM4IDQxLjA2MDkgMzggNDBWMTRIMTJaTTMzLjIzNiA4TDMwIDRIMThMMTQuNzY0IDhINlYxMkg0MlY4SDMzLjIzNloiIGZpbGw9IiM5MDlBOUYiLz4KPC9zdmc+Cg==";